<template>
	<component :is="component" :class="$style.root">
		<slot />
	</component>
</template>

<script>

import defaultRootComponent from '../defaultRootComponent'

export default {
  name: 'DialogHeader',

  mixins: [ defaultRootComponent('div') ],

  props: ['title']
}

</script>

<style module>

.root {
	@apply
		p-4
		border-b
		border-dull;
}

</style>
